import script from "./VenteView.vue?vue&type=script&setup=true&lang=js"
export * from "./VenteView.vue?vue&type=script&setup=true&lang=js"

import "./VenteView.vue?vue&type=style&index=0&id=509abfa3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-509abfa3"]])

export default __exports__